import { getData, postData, patchData, delData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';
import { CreateGameProfileQuestionSetPayload, GameProfileQuestionSet } from '../../../types/gameProfileQuestionSet';

interface GameProfileQuestionSetsResponse {
  groupSets?: GameProfileQuestionSet[];
  data?: GameProfileQuestionSet[];
}

interface SuccessResponse {
  success: boolean;
}

export const getGameProfileQuestionSetsRepository = async (country: string): Promise<GameProfileQuestionSet[]> => {
  const url = `${API_URLS.GAME_PROFILE_QUESTION_SETS_API}?country=${country}`;
  const response = await getData<any, GameProfileQuestionSetsResponse>(url);
  const payload = response.data || {};
  return payload.groupSets || (payload.data as GameProfileQuestionSet[]) || [];
};

export const createGameProfileQuestionSetRepository = async (
  payload: CreateGameProfileQuestionSetPayload,
): Promise<void> => {
  await postData<CreateGameProfileQuestionSetPayload, SuccessResponse>(
    API_URLS.GAME_PROFILE_QUESTION_SETS_API,
    payload,
  );
};

export const updateGameProfileQuestionSetRepository = async (
  id: string,
  payload: CreateGameProfileQuestionSetPayload,
): Promise<void> => {
  await patchData<CreateGameProfileQuestionSetPayload, SuccessResponse>(
    API_URLS.GAME_PROFILE_QUESTION_SET_DETAIL_API(id),
    payload,
  );
};

export const getGameProfileQuestionSetDetailRepository = async (id: string): Promise<GameProfileQuestionSet> => {
  const response = await getData<any, GameProfileQuestionSet>(API_URLS.GAME_PROFILE_QUESTION_SET_DETAIL_API(id));
  return response.data;
};

export const updateGameProfileQuestionSetStatusRepository = async (id: string, disabled: boolean): Promise<void> => {
  await patchData<{ disabled: boolean }, SuccessResponse>(API_URLS.GAME_PROFILE_QUESTION_SET_STATUS_API(id), {
    disabled,
  });
};

export const deleteGameProfileQuestionSetRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.GAME_PROFILE_QUESTION_SET_DETAIL_API(id));
};
